module.exports = __webpack_public_path__ + "static/media/kenco-logo.e466285b.svg";